import { gql } from '@apollo/client'
import { createContext, useContext } from 'react'

import { SegmentationProvider_DocumentFragment } from './__generated__/segmentation-hook.graphql'

export type SegmentationProviderProps = {
  children: React.ReactNode
  segmentationData: SegmentationProvider_DocumentFragment['publicationSegmentation']
}

export const SegmentationContext =
  createContext<SegmentationProvider_DocumentFragment['publicationSegmentation']>(null)

export function useSegmentation() {
  const context = useContext(SegmentationContext)
  return context
}

export const SegmentationProvider = (props: SegmentationProviderProps) => {
  const { segmentationData, children } = props

  return (
    <SegmentationContext.Provider value={segmentationData}>{children}</SegmentationContext.Provider>
  )
}

SegmentationProvider.fragments = {
  document: gql`
    fragment SegmentationProvider_document on Document {
      publicationSegmentation {
        typeSegmentation
        mainTheme
        ctaUrl
        ctaText
      }
    }
  `,
}
